import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AllocationImplementation } from '../models/allocation-implementation.enum';

@Pipe({
  name: 'allocationStatus'
})
export class AllocationStatusPipe implements PipeTransform {

  public transform(value: string): string {
    if (!value) {
        return value;
    }

    switch(value) {
      case 'Created': {
        return 'Created';
      }
      case 'Processing': {
        return 'In Progress';
      }
      case 'FailedToProcess': {
        return 'Failed To Process';
      }
      case 'Pending': {
        return 'Pending';
      }
      case 'CompletedManually': {
        return 'Completed Manually';
      }
      case 'RejectedManually': {
        return 'Rejected Manually';
      }
      case 'SyncStarted': {
        return 'Sync Started';
      }
      case 'SyncFailed': {
        return 'Sync Failed';
      }
      case 'SyncStartedManually': {
        return 'Sync Started Manually';
      }
      case 'SyncCompleted': {
        return 'Sync Completed';
      }
      default: {
        let pipedValue: string = value;

        if (environment.AllocationImplementation === AllocationImplementation.Manual) {
          switch (pipedValue) {
              case 'CompletedManually': {
                pipedValue = 'Completed';
                break;
              }
              case 'FailedToProcess': {
                pipedValue = 'Failed';
                break;
              }
          }
        }

        return pipedValue.replace(/([A-Z])/g, ' $1').trim();
      }
    }
  }

}
